import { startScriptTool } from "./script-tool.js";
import { startTools } from "./start-tools.js";

/**
 * The bundle for the 简体 and 繁體 converter.
 *
 * It exports nothing, and that is the point — a module whose whole purpose is
 * a side effect should not also be something other modules import.
 */
startTools(document, new Map([["script", startScriptTool]]));
